import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { SipTrunkConst, SipTrunkTypeArray } from './siptrunk.const';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import * as _ from 'lodash';
import { AdminIvrGatewayService } from '../../../../../../common/services/admins/ivrGateway.service';
import { isEmail, isNumber, isPhoneNumber } from '../../../../../../common/utils/validate';

@Component({
  selector: 'setting-account-siptrunk',
  templateUrl: './siptrunk.component.html',
  styleUrls: ['./siptrunk.component.css'],
  providers: [AdminIvrGatewayService], // replace with actual service name, if it's different from the one imported above.'
})
export class SiptrunkComponent extends BaseListComponent {
  @ViewChild('template') template: ElementRef;

  @Input() tenantId: string = null;
  public modelFilter: any = {};
  public allTypes: any = [{ id: '', text: 'Chọn' }, ...SipTrunkTypeArray];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private ivrgatewayService: AdminIvrGatewayService // replace with actual service name
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = SipTrunkConst.displayColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.ivrgatewayService.list(this.tenantId, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.data = res.data.ivrgateways;
          this.data = this.data.map(res => {
            res.display_type = SipTrunkConst.displayTypeColumns(res.type);
            return res;
          });
          this.initPage(res.data.total);
        } else {
          this.throwError();
        }
      },
      err => this.throwError
    );
  }

  async search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      await this.loadData({ sipurl: this.modelFilter.keyword.trim() });
    } else {
      await this.loadData();
    }
  }

  async add(payload) {
    this.ivrgatewayService.create(this.tenantId, payload).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async update(id, payload) {
    this.ivrgatewayService._update(this.tenantId, id, payload).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async openConfirmDelete() {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.ivrgatewayService._delete(this.tenantId, this.delete_id).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Xóa thành công!');
            this.loadData();
          } else {
            this.throwError(res.message);
          }
        },
        error => {
          this.throwError(error.message);
        }
      );
    }
  }

  ///
  async setUpModel(type) {
    this.typeModal = type;
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới cổng kết nối' : 'Cập nhật cổng kết nối',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'type',
        label: 'Loại',
        type: FormFieldType.Select2,
        value: this.model.type,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
        options: {
          data: this.allTypes,
          select2Options: {
            placeholder: { id: '', text: 'Chọn' },
          },
        },
      },
      {
        key: 'line',
        label: 'Đầu số',
        type: FormFieldType.Text,
        value: this.model.line,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
      },
      {
        key: 'sipurl',
        label: 'Url',
        type: FormFieldType.Text,
        value: this.model.sipurl,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
      },
      {
        key: 'description',
        label: 'Mô tả',
        type: FormFieldType.Textarea,
        value: this.model.description,
        required: false,
        disabled: false,
        width: 'full',
        order: 2,
      },
    ];
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        await this.setUpModel('add');
        this.openModal(this.template, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
          }
        });
        await this.setUpModel('edit');
        this.openModal(this.template, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        this.delete_id = item.ivrgateway_id;
        await this.openConfirmDelete();
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    const payload = {
      type: this.model.type,
      sipurl: this.model.sipurl,
      description: this.model.description,
      line: this.model.line,
    };
    if (this.typeModal === 'add') {
      await this.add(payload);
    } else if (this.typeModal === 'edit') {
      await this.update(this.model.ivrgateway_id, payload);
    }
  }
  async onChangeValueModel(key, item?: any) {
    this.message = null;
    this.model = _.merge({}, this.model, item);
    switch (key) {
      case 'line':
        if (this.model.line && !isPhoneNumber(this.model.line) && !isNumber(this.model.line)) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Đầu số không đúng định dạng!',
          };
        }
        break;
    }
    await this.setUpModel(this.typeModal);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/account/siptrunk/siptrunk.component.ts